import { BannerAPIContentType } from '../../services/responseTypes/BannerApiResponse';
import { TAG_NAME } from '../constants/TagNameConstants';
import { getImageURL } from '../ImageHelper/ImageURLGenerator';

export const getBannerImageURL = (
  deviceWidth: number,
  bannerImage: BannerAPIContentType
) => {
  return getImageURL({
    deviceWidth,
    tagName: TAG_NAME.PORTRAIT_SMALL_BG,
    item: bannerImage
  });
};
